<!-- <app-news-letter> </app-news-letter> -->

<!-- ======= Footer ======= -->
<footer id="footer" >
    <div class="container-fluid" class="background">
        <div class="row d-flex align-items-center">
            <!-- <div class="row"> -->
            <div class="col-sm-12 col-md-10 col-lg-10">
                <div class="row">
                    <div class="col-sm-12 col-md-3 col-lg-3 ps-5 pt-4 pb-3 logo-image padding-less-mobile">
                        <div class="row pub-logo">
                            <div class="col text-center">
                                <!-- <img *ngIf="themeSettingsData && themeSettingsData.journal_logo"
                                    src="{{ themeSettingsData.journal_logo}}" class="rvh-footer-pub-logo-image"
                                    [alt]="themeSettingsData.logo_alt_text" routerLink="/"> -->
                                <img class="img-fluid rvt-logo pb-2" class="rvh-footer-pub-logo-image" tabindex="0" width="187" height="80"
                                    [src]="'assets/logos/ba_logo_white.webp'" [alt]="'app_footer.rvhost_logo'|translate" appLazyLoad/>
                            </div>
                            <div class="row d-none">
                                <div class="col-sm col-md pb-2 d-flex justify-content-center">
                                    <ng-container *ngIf="themeSettingsData">
                                        <a *ngFor="let media of themeSettingsData.social_media_links" class="pl-3"
                                            href="{{media.value}}" role="link" [attr.aria-label]="media.label" title="{{media.label}}">
                                            <fa-icon aria-hidden="true" *ngIf="media.icon"
                                                [icon]="media.icon"></fa-icon>
                                        </a>
                                    </ng-container>

                                </div>
                            </div>
                        </div>

                        <div class="row mt-2" *ngIf="themeSettingsData && themeSettingsData.contact_us">
                            <div class="col text-center journal-address p-0" tabindex="0" [attr.aria-label]="themeSettingsData.contact_us.address_line_1 +themeSettingsData.contact_us.address_line_2
                            +themeSettingsData.contact_us.address_line_3">
                                <!-- <p class="Roboto-light" 
                                [attr.aria-label]="themeSettingsData.contact_us.address_line_1" >
                                {{themeSettingsData.contact_us.address_line_1}}</p>
                                <p class="Roboto-light"
                                [attr.aria-label]="themeSettingsData.contact_us.address_line_2">
                                    {{themeSettingsData.contact_us.address_line_2}}</p>
                                <p class="Roboto-light" 
                                [attr.aria-label]="themeSettingsData.contact_us.address_line_3">
                                {{themeSettingsData.contact_us.address_line_3}}</p> -->
                                <!-- <div class="rvt-section">
                                    <p class="Roboto-light p-2 pub-info" tabindex="0">
                                        The British Academy is the UK’s national academy for the humanities and social sciences. We mobilise these disciplines to understand the world and shape a brighter future. ​
                                    </p>
                                </div> -->
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-4 col-sm-4 col-md-3 col-lg-3 pt-4 about-menu-sec text-color d-lg-block">
                        <p class="Roboto-medium h5">{{'app_header.about' | translate}}</p>
                        <ul class="nav flex-column Roboto-light">
                            <li class="nav-item mb-2 text-color"><a tabindex="0" [routerLink]="" role="link"
                                    [attr.aria-label]="'app_footer.about_us' | translate"
                                    class="nav-link p-0 text-muted text-color">{{'app_footer.about_us' | translate}}</a>
                            </li>
                            <li class="nav-item mb-2 text-color"><a tabindex="0" [routerLink]="" role="link"
                                    [attr.aria-label]="'app_footer.careers' | translate"
                                    class="nav-link p-0 text-muted text-color">{{'app_footer.careers' | translate}}</a>
                            </li>
                            <li class="nav-item mb-2 text-color"><a tabindex="0" [routerLink]="" role="link"
                                    [attr.aria-label]="'app_footer.contact_us' | translate"
                                    class="nav-link p-0 text-muted text-color">{{'app_footer.contact_us' |
                                    translate}}</a></li>
                            <li class="nav-item mb-2 text-color"><a tabindex="0" [routerLink]="" role="link"
                                    [attr.aria-label]="'app_footer.sitemap' | translate"
                                    class="nav-link p-0 text-muted text-color">
                                    {{'app_footer.sitemap' | translate}}
                                </a></li>
                        </ul>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 col-lg-3 pt-4 ft-menu">
                        <p class="Roboto-medium h6 text-color">{{'app_footer.support' | translate}}</p>
                        <ul class="nav flex-column Roboto-light">
                            <li class="nav-item mb-2"><a tabindex="0" [routerLink]="" role="link"
                                    [attr.aria-label]="'app_footer.help' | translate"
                                    class="nav-link p-0 text-muted text-color">
                                    {{'app_footer.help' | translate}} / {{'app_footer.faq' | translate}}</a></li>
                            <li class="nav-item mb-2"><a tabindex="0" [routerLink]="" role="link"
                                    [attr.aria-label]="'app_footer.accessibility' | translate"
                                    class="nav-link p-0 text-muted text-color">{{'app_footer.accessibility' |
                                    translate}}</a></li>
                            <li class="nav-item mb-2">
                                <a [href]="rss_feed_url" tabindex="0" role="link"
                                    [attr.aria-label]="'app_footer.rss_feed' | translate"
                                    class="nav-link p-0 text-muted text-color" target="_blank">
                                    {{ 'app_footer.rss_feed' | translate }}
                                </a>
                            </li>


                        </ul>
                    </div>

                    <div class="col-4 col-sm-4 col-md-3 col-lg-3 pt-4 ft-menu border-md">
                        <p class="Roboto-medium h6 text-color">{{'app_footer.legal' | translate}}</p>
                        <ul class="nav flex-column Roboto-light">
                            <li class="nav-item mb-2"><a tabindex="0" [routerLink]=""
                                    class="nav-link p-0 text-muted text-color">{{'app_footer.terms' |
                                    translate}}</a></li>
                            <li class="nav-item mb-2 text-color"><a tabindex="0" [routerLink]=""
                                    class="nav-link p-0 text-muted text-color">{{'app_footer.privacy_policy' |
                                    translate}}</a></li>
                            <li class="nav-item mb-2"><a tabindex="0" [routerLink]=""
                                    class="nav-link p-0 text-muted text-color">{{'app_footer.copyrights' |
                                    translate}}</a></li>
                            <li class="nav-item mb-2"><a tabindex="0" [routerLink]=""
                                    class="nav-link p-0 text-muted text-color">{{'app_footer.trust' |
                                    translate}} & {{'app_footer.security' | translate}}</a></li>
                        </ul>
                    </div> -->

                </div>
            </div>

            <div class="col-sm-6 col-md-2 col-lg-2 ps-5 pt-4 pb-3 logo-ba">
                <div class="rvt-section">
                    <img width="187" height="80" class="img-fluid rvt-logo pb-2" class="rvh-footer-pub-logo-image" tabindex="0" 
                    [src]="'assets/logos/ba_logo_white.webp'" [alt]="'app_footer.rvhost_logo'|translate" appLazyLoad />
                </div>

            </div>

            <div class=" col-sm-6 col-md-2 col-lg-2 pt-4 pb-3 logo-md" >
                <div class="rvt-section">

                    <img width="121" height="93" class="img-fluid rvt-logo pb-2 rvt-logo-md" tabindex="0" 
                    [src]="'assets/logos/rvt_logo_white.webp'" 
                    [alt]="'app_footer.rvhost_logo'|translate" appLazyLoad />
                    
                </div>
            </div>
            <!-- </div> -->
            <!-- </div> -->

            <div class="d-flex justify-content-center border-top rvt-footer text-color">
                <p class="copyright-footer"> 
                    Copyright &copy; {{currentYear}} <a href="https://rivervalley.io/" target="_blank" class="footer-rvt-label">River Valley Technologies Limited</a>. All rights reserved.
                </p>
            </div>

            <div class="respncive-nav-head-content pl-4 d-flex rvh-lang-sec primary-header" *ngIf="showLanguageDropDown">
                <div class="dropdown" *ngFor="let language of activeLanguages">
                    <a role="button" tabindex="0" [attr.aria-label]="'aria_label.language'|translate" title="{{language.language_name}}"
                        aria-haspopup="listbox" data-bs-toggle="dropdown" aria-expanded="false" id="dropdownLanguage"
                        class="padding-to-options rvh-lang-flag" aria-expanded="false">
                        <span class="fi fi-{{currentCountryCode}} size"></span>
                        <!-- <a class="padding pl-2" value="language.country_language_code"
                        (click)="changeSiteLanguage(language.country_language_code)"
                        (keyup.enter)="changeSiteLanguage(language.country_language_code)"
                        (keyup.space)="changeSiteLanguage(language.country_language_code)"><span
                            style="margin-left: 2px;"
                            class="fi fi-{{returnCountryCode(language.country_language_code)}}"></span> -->
                        <!-- </a> -->

                        <span (click)="changeSiteLanguage(language.country_language_code)"
                            (keyup.enter)="changeSiteLanguage(language.country_language_code)"
                            (keyup.space)="changeSiteLanguage(language.country_language_code)" class="pl-2"
                            style="color: #ffffff;">{{language.language_name}}
                            (<small>{{language.country_name}}</small>)</span>
                        <!-- <fa-icon aria-hidden="true" [icon]="['fas','chevron-down']"></fa-icon> -->
                        <!-- <i class="bi bi-chevron-down"></i> -->
                    </a>
                    <fa-icon aria-hidden="true" [icon]="['fas','sort-up']" class="sort-up"></fa-icon>
                    <ul class="dropdown-menu" role="listbox" aria-labelledby="dropdownLanguage" aria-expanded="false">

                        <li style="cursor:pointer;" role="option" *ngFor="let language of activeLanguages"
                            class="nav-list rvhws-language-list p-1" tabindex="0"
                            [attr.aria-label]="language.language_name">
                            <a class="padding pl-2" value="language.country_language_code" title="{{language.language_name}}"
                                (click)="changeSiteLanguage(language.country_language_code)"
                                (keyup.enter)="changeSiteLanguage(language.country_language_code)"
                                (keyup.space)="changeSiteLanguage(language.country_language_code)"><span
                                    style="margin-left: 2px;"
                                    class="fi fi-{{returnCountryCode(language.country_language_code)}}"></span>
                            </a>
                            <span (click)="changeSiteLanguage(language.country_language_code)"
                                (keyup.enter)="changeSiteLanguage(language.country_language_code)"
                                (keyup.space)="changeSiteLanguage(language.country_language_code)"
                                class="pl-2">{{language.language_name}}
                                (<small>{{language.country_name}}</small>)</span>
                        </li>

                    </ul>
                </div>
            </div>

        </div>
    </div>
</footer>
<!-- ======= End Footer ======= -->

<a href="#" class="back-to-top d-flex align-items-center justify-content-center">
    <!-- <i class="bi bi-arrow-up-short"></i> -->
    <fa-icon [icon]="['fas','arrow-up']" aria-hidden="true" ></fa-icon>
</a>